import React from 'react'
import PropTypes from 'prop-types'

import { BadgePill, Icon, InlineButton } from '../../../index'
import { useVisibility } from '../../../../utils'
import { useTranslation } from '../../../../utils/providers'

import FilterFlyout from './FilterFlyout'

function FilterButton({ numberOfActiveFilters, resetAllFilters, ...rest }) {
  const { t } = useTranslation()
  const { isVisible, show, hide } = useVisibility()

  const reset = (e) => {
    resetAllFilters(e)
    hide(e)
  }

  const label = t('MOBILE_FILTER_ACTION')

  return (
    <>
      <InlineButton
        title={label}
        aria-label={label}
        aria-expanded={isVisible}
        aria-controls="product-list-filter-form"
        onClick={show}
        className="d-flex justify-content-center align-items-center px-3 py-1"
      >
        {numberOfActiveFilters > 0 && (
          <BadgePill variant="primary" className="mr-3">
            {numberOfActiveFilters}
          </BadgePill>
        )}
        <Icon symbol="cf-filter" />
      </InlineButton>
      <FilterFlyout
        isVisible={isVisible}
        hide={hide}
        numberOfActiveFilters={numberOfActiveFilters}
        resetAllFilters={reset}
        {...rest}
      />
    </>
  )
}

FilterButton.propTypes = {
  numberOfActiveFilters: PropTypes.number,
  resetAllFilters: PropTypes.func,
}

export default FilterButton
